
/**
 * @file loginページ
 * @description HOMEページ用スクリプト
 * @author lincrea.co.jp
 * @version 1.0.0
 */
import * as SPIRIT from "../SPIRIT";
import { PasswordChangeModal } from "../views/modal/passowrdChangeModal";



/**
 * @description ページの要素を構築する 
 */
function build() {

}

/**
 * @description 各種イベントのバインド
 */
function setEvents() {


}

/**
 * @description onReady Block
 */
$(function () {


    build();
    setEvents();

    //ナビゲーション時にかなりちらつくのでやめ
    ////#1978 進捗表、サマリ、など、プロジェクト配下に属する子画面が存在する場合閉じる
    //SPIRIT.util.window.closeSubWindow();

    //if ($('#IsNeedChangePasssword').data('isneedchangepasssword') === 'True') {
    if ($('#IsNeedChangePasssword').val() === 'True') {

        var UserName = $('#UserName').val();
        var MailAddress = $('#MailAddress').val();
        var Password = $('#Password').val();
        var IsAdminUser = $('#IsAdminUser').val();
        //#4346
        //let passwordChangeModal = new PasswordChangeModal(<string>UserName, <string>MailAddress);
        let passwordChangeModal = new PasswordChangeModal(<string>UserName, <string>MailAddress, null, true);

        passwordChangeModal.onShow = (p, e) => {
            //passwordChangeModal.accountNm.text = <string>UserName;
            //passwordChangeModal.accountMail.text = <string>MailAddress;
            //passwordChangeModal.password.text = <string>Password;
            //passwordChangeModal.IsAdminUser = (IsAdminUser === 'True') ? true : false;
            return true;
        };

        passwordChangeModal.onClosed = (modal, e) => {
            if (modal.dialogResult) {
                if (modal.dialogResult == 'ok') {

                    //#3003 画面遷移をすこし遅らせる（本来は、遷移先で表示する事が好ましいが...）
                    setTimeout(function () {
                        //ターゲット先に遷移
                        var returnUrl = $('#ReturnUrl').val();
                        if (returnUrl) {
                            SPIRIT.util.execGet(returnUrl);
                        }
                    }, 1500);
                }
            }
        };

        //もう必要ない
        //    passwordChangeModal.onComplated = () => {
        //        passwordChangeModal.show();
        //    };

        passwordChangeModal.show();

    }
});
